"use client";

import { createContext, useContext, useEffect, useMemo } from "react";
import { DEFAULT_LESSON_PREFERENCES, type LessonPreferences } from "@lib/lessonPreferences";
import { setClientLessonPreferences } from "@lib/lessonPreferencesClient";

type LessonPreferencesContextValue = {
  preferences: LessonPreferences;
};

const LessonPreferencesContext = createContext<LessonPreferencesContextValue>({
  preferences: DEFAULT_LESSON_PREFERENCES,
});

export function LessonPreferencesProvider({
  preferences,
  children,
}: {
  preferences: LessonPreferences;
  children: React.ReactNode;
}) {
  const value = useMemo((): LessonPreferencesContextValue => ({ preferences }), [preferences]);

  useEffect(() => {
    setClientLessonPreferences(value.preferences);
  }, [value.preferences]);

  return (
    <LessonPreferencesContext.Provider value={value}>{children}</LessonPreferencesContext.Provider>
  );
}

export function useLessonPreferences(): LessonPreferences {
  return useContext(LessonPreferencesContext).preferences;
}
